"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var DummyProvider_1 = require("./DummyProvider");
var FormProvider_1 = require("./FormProvider");
exports.EntityElement = function (_a) {
    var id = _a.id, component = _a.component;
    return (React.createElement(FormProvider_1.FormComponents.Consumer, null, function (components) {
        if (components === void 0) { components = {}; }
        var Component = components[component.toUpperCase()] || DummyProvider_1.default;
        return React.createElement(Component, { key: id, id: id });
    }));
};
exports.mapState = function (state, props) { return ({
    component: state.component[props.id],
}); };
exports.EntityProvider = react_redux_1.connect(exports.mapState)(exports.EntityElement);
//# sourceMappingURL=EntityProvider.js.map